<!--实时电能质量,三相电压和不平衡度-->
<template>
  <div class="realPowerQualityBody">
    <!--日期弹窗-->
    <elRadioTree slot="tree" :dataList='virtualDeviceList' @checkItem="nowVirtualDevice = $event"></elRadioTree>
    <div class="pageBody" slot="body">
      <div class="buttonLine">
        <label>应用类型组：</label>
        <el-select v-model="nowApptypeGroups" value-key="id" @change="changeTelescopic" multiple collapse-tags
          placeholder="请选择">
          <el-option v-for="item in apptypeGroups" :key="item.id" :label="item.name" :value="item">
          </el-option>
        </el-select>
        <!-- <iconButton @buttonClick='downloadExcel' buttonText='导出' icoName="wedoButton/download.png"></iconButton> -->
        <el-button type="primary" plain @click="downloadExcel" style="margin-left:15px">导出</el-button>
      </div>
      <!--图表-->
      <vchart style="height: calc(65% - 0.37rem);background-color: white;" ref='vchart'></vchart>
      <!--表格显示数据-->
      <div class="mytable">

        <el-table :data="nowPage" :header-cell-style="{'text-align':'center','background': '#F1F4F7'}"
          :cell-style="{'text-align':'center'}" height="2.85rem;width:95%" border>
          <template slot="empty">
            <span class="noData">
              <span class="text">暂无数据</span>
            </span>
          </template>
          <el-table-column fixed type="index" width="50"></el-table-column>
          <el-table-column fixed prop="0" label="名称" width="180">
          </el-table-column>
          <el-table-column v-for='(item,index) in columns' :prop="(index+1).toString()" :label="item.name"
            :key="item.key">
          </el-table-column>
        </el-table>
        <!-- <el-table :data="dataList" height="2.85rem;width:95%" border style="width: 100%">
          <template slot="empty">
            <span class="noData">
              <img src="../../assets/noData.png" alt="暂无数据">
              <span class="text">暂无数据</span>
            </span>
          </template>
          <el-table-column label="序号" width="90" align="center">
            <template slot-scope="scope">
              <span>{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="variableName" label="变量名" width="180" align="center"> </el-table-column>
          <el-table-column prop="value" label="实时值" align="center"> </el-table-column>
        </el-table> -->
      </div>
      <!-- <infoList ref="infoList" style="height: 3.5rem;" :columns='columns' :dataList="dataList" :pageLen='dataList.length <6?6:dataList.length' :totalSize="dataList.length" :fillAll="true" :showIndex='false'></infoList> -->
    </div>
  </div>
</template>
<script>
  import treeBody from '@/components/module/slotModule/treeBody.vue'
  import iconButton from '@/components/module/universal/iconButton.vue'
  import vchart from '@/components/module/chart/vchart.vue'
  import infoList from '@/components/module/universal/infoList.vue'
  import multipleSelection from '@/components/module/selection/multipleSelection.vue'
  import elRadioTree from '@/components/module/tree/elRadioTree.vue'
  export default {
    components: {
      treeBody,
      iconButton,
      vchart,
      infoList,
      multipleSelection,
      elRadioTree,
    },
    props: {},
    data () {
      return {
        dataList: this.$store.resourcesStore.state.nowPage,
        from2name: {},
        nowVirtualDevice: undefined,
        nowApptypeGroups: [],
        nowSeries: [],
        refreshInterval: 2000,
        apptypeGroupsList: [],
        columns: [{
          name: '变量名称',
          key: 'variableName'
        },{
          name: '实时值',
          key: 'value'
        }],
        options: this.$store.resourcesStore.state.options,
      }
    },
    created () {},
    mounted () {
      debugPage=this
      this.options.title.text='设备-实时电能质量'
      this.$refs.vchart.setData(this.options,true)

    },
    destroyed () {
      this.realTimeValueStore.commit("removeKeys",this.variableNameList)
      removeTask('refreshRealPowerQuality')
    },
    computed: {
      getBackgroudImageStyle () {
        return this.$store.resourcesStore.getters.getBackgroudImageStyle
      },
      getResourcesByName () {
        return this.$store.resourcesStore.getters.getResourcesByName
      },
      variableStore () {
        return this.$store.variableStore
      },
      archivesStore () {
        return this.$store.archivesStore
      },
      deviceStore () {
        return this.$store.deviceStore
      },
      nowUnit () {
        return this.$store.unitStore.getters.getNowUnit
      },

      virtualDeviceList () {
        var data=this.$store.deviceStore.getters.getReadDeviceTree
        return isempty(data)? []:[deviceList(data)]
      },
      realTimeValueStore () {
        return this.$store.realTimeValueStore
      },
      variableTree () {
        if(this.nowVirtualDevice==undefined) {
          return []
        }
        console.log(this.nowVirtualDevice.no,'this.nowVirtualDevice.no')
        return this.$store.variableStore.getters.getVariableTree(this.nowVirtualDevice.no)
      },
      variableNameList () {
        //当前应该显示的变量fromname列表
        var ag=[]
        for(var i=0,len=this.nowApptypeGroups.length;i<len;i++) {
          var item=this.nowApptypeGroups[i]
          if(item.id==-1||item.id==-2) {
            ag=ag.concat(item.next.map(ni => {
              return ni.id
            }))
          } else {
            ag.push(item.id)
          }
        }
        // console.log(ag,'ag')
        console.log(this.variableTree,'variableTree')
        var v1=this.variableTree.filter(item => {
          return ag.includes(item.no)
        })
        // console.log(v1,'v1')
        if(isempty(v1)) {
          return []
        }
        var v2=[]
        v1.forEach(item => {
          item.next.forEach(i => {
            this.from2name[i.fromName]=i.name
            v2.push(i.fromName) //fromName
          })
        })
        return v2
      },
      apptypeGroups () {
        let appApptypeArr=this.$store.variableStore.state.powerApptypeGroup;
        console.log(appApptypeArr,'appApptypeArr')
        if(!isempty(appApptypeArr)) {
          this.nowApptypeGroups=[appApptypeArr[0]];
        }
        // console.log(this.nowApptypeGroups,'nowApptypeGroups')
        return this.$store.variableStore.state.powerApptypeGroup
      }
    },
    watch: {
      variableNameList (nv,ov) {

      },
    },
    methods: {
      downloadExcel () {
        // let title = '<thead><tr>'
        // title += '<th colspan=6>' +new Date().formatByTime('-')+' 实时质量' +'</th>'
        // title += '</tr></thead>'
        this.$refs.infoList.downloadExcel('实时质量');
        // let k = document.getElementById("table_data").outerHTML;
        // let aa = document.getElementsByTagName('thead')[0];//头部表达
        // let bb = document.getElementsByTagName('tbody')[0];//列表内容
        // let table = title + aa.innerHTML + bb.innerHTML
        // exportToExcel(table, "实时质量报告")
      },
      changeTelescopic (data) {
        console.log(data)
        console.log(this.nowApptypeGroups,11)
      },
      addData () {
        //获取值
        if(this.$refs.vchart==undefined) {
          removeTask('refreshRealPowerQuality')
          return
        }
        var vl=this.realTimeValueStore.getters.getValue(this.variableNameList)
        var now=new Date().getTime()
        this.nowSeries.forEach((item,index) => {
          item.data.shift()
          var temp=vl[index]
          if(isNaN(parseFloat(temp))||isnull(parseFloat(temp))) {
            temp=undefined
          }
          item.data.push([now,temp])
        })
        if(this.$refs.vchart!=undefined) {
          this.$refs.vchart.setData({
            series: this.nowSeries
          })
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  .pageBody {
    width: 100%;
    height: 98%;
    /* padding-bottom: 60px;
		padding-top: 75px; */

  }

  /deep/.el-select-dropdown__list {
    width: 100% !important;
  }

  .mytable {
    padding: 0 20px;
  }

  /deep/.el-table th,
  .el-table tr {
    background-color: #f3f8ff !important;
  }

  /deep/.el-tree {
    width: 2.65rem !important;
    min-width: 2.55rem !important;
  }

  .realPowerQualityBody {
    width: 100%;
    display: flex !important;
    /* align-items: center; */
    background-color: #fff;
    justify-content: space-between;
  }
</style>